module.exports = __webpack_public_path__ + "img/Group 28138@2x.8791ffbe.png";